import { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

import { Menu } from "./styles";
import { DropdownMenuProps } from "./types";

interface MenuCoords {
  top: number;
  left: number;
  right: number;
}

const INITIAL_COORDS: MenuCoords = { top: 0, left: 0, right: 0 };
const MENU_GAP = 6;

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  anchorRef,
  menuRef,
  align,
  children,
}) => {
  const [coords, setCoords] = useState<MenuCoords>(INITIAL_COORDS);

  useLayoutEffect(() => {
    const node = anchorRef.current;
    if (!node) {
      return;
    }

    const updateCoords = () => {
      const rect = node.getBoundingClientRect();
      setCoords({
        top: rect.bottom + MENU_GAP,
        left: rect.left,
        right: window.innerWidth - rect.right,
      });
    };

    updateCoords();
    window.addEventListener("resize", updateCoords);
    window.addEventListener("scroll", updateCoords, true);

    return () => {
      window.removeEventListener("resize", updateCoords);
      window.removeEventListener("scroll", updateCoords, true);
    };
  }, [anchorRef]);

  return createPortal(
    <Menu
      ref={menuRef}
      role="listbox"
      $align={align}
      $top={coords.top}
      $left={coords.left}
      $right={coords.right}
    >
      {children}
    </Menu>,
    document.body,
  );
};

export default DropdownMenu;
